import { Search } from "@mui/icons-material";
import { API } from "./API";

export const PhoneSearchAPI = {
  GetUserGroupRelatedLoginName: async (groupId, searchText, isOnLoad) => {

    let data = JSON.stringify({
      requestValue: {
        groupId: groupId,
        searchText: searchText,
        isOnLoad: isOnLoad
      },
    })

    return await API.post(`PhoneSearch/GetUserGroupRelatedLoginName`, data);
  },
  GetUserEuIdByLoginName: async (loginName) => {
    let data = JSON.stringify({
      requestValue: {
        loginName: loginName
      },
    });

    return await API.post(`SendingReport/GetUserEuIdByLoginName`, data);
  },

};